﻿import { projectSettings } from "../../config";

import LandingPage from "./LandingPage.svelte";
import PersonalDetails from "./PersonalDetails.svelte";
import ClaimDetails from "./ClaimDetails.svelte";
import DocumentUpload from "./DocumentUpload.svelte";
import Confirmation from "./Confirmation.svelte";
import Review from "./Review.svelte";
import ThankYou from "./ThankYou.svelte";

const title = projectSettings.classActionName;

const registrationPageList = [
    {
        pageIndex: 0,
        component: LandingPage,
        title: null,
        showInTracker: false,
        routeId: "/Registration",
        nextPage: "/Registration/PersonalDetails",
        properties: {
            pageTitle: `${title}`,
            lastVisitedPage: "Landing Page",
        },
    },
    {
        pageIndex: 1,
        component: PersonalDetails,
        title: "Personal Details",
        showInTracker: true,
        routeId: "/Registration/PersonalDetails",
        nextPage: "/Registration/ClaimDetails",
        previousPage: "/Registration",
        properties: {
            pageTitle: `${title} - Personal Details`,
            persistUrl: "/api/project",
            lastVisitedPage: "Personal Details",
        },
    },
    {
        pageIndex: 2,
        component: ClaimDetails,
        title: "Claim Details",
        showInTracker: true,
        routeId: "/Registration/ClaimDetails",
        nextPage: "/Registration/Confirmation",
        previousPage: "/Registration/PersonalDetails",
        properties: {
            pageTitle: `${title} - Claim Details`,
            persistUrl: "/api/project",
            lastVisitedPage: "Claim Details",
        },
    },
    {
        pageIndex: 6,
        component: DocumentUpload,
        title: "Document Upload",
        showInTracker: true,
        routeId: "/Registration/DocumentUpload",
        previousPage: "/Registration/ClaimDetails",
        nextPage: "/Registration/Confirmation",
        properties: {
            pageTitle: `${title} - Document Upload`,
            persistUrl: "/api/project",
            lastVisitedPage: "Document Upload",
        },
    },
    {
        pageIndex: 7,
        component: Confirmation,
        title: "Confirmation",
        showInTracker: true,
        routeId: "/Registration/Confirmation",
        previousPage: "/Registration/ClaimDetails",
        nextPage: "/Registration/ThankYou",
        properties: {
            pageTitle: `${title} - Confirmation`,
            nextPageLabel: "Submit",
            persistUrl: `/api/registration`,
            lastVisitedPage: "Confirmation",
        },
    },
    {
        pageIndex: 9,
        component: ThankYou,
        title: "Registration Submitted",
        showInTracker: false,
        routeId: "/Registration/ThankYou",
        properties: {
            pageTitle: `${title} - Thank you`,
        },
    },
    {
        pageIndex: 10,
        component: Review,
        title: "Review",
        showInTracker: false,
        routeId: "/Review",
        properties: {
            pageTitle: `${title} - Review`,
        },
    },
];


export default registrationPageList
